import 'firebase/compat/firestore';
import { useContext, useEffect, useState } from 'react';
import migrateScope, { migrateDrillDowns } from '../migrateScope';
import AccountPickerContext from '../contexts/AccountPickerContext';
import DraftSavedFiltersContext from '../contexts/DraftSavedFiltersContext';
import STORE from '../store';

const migrate = (sf: LegacySavedFilter): LegacySavedFilter => {
  return {
    ...sf,
    scope: migrateScope(sf.scope),
    drillDowns: sf.drillDowns ? migrateDrillDowns(sf.drillDowns) : [],
  };
};

const useLegacySavedFilter = (id: string | undefined) => {
  const [isLoading, setIsLoading] = useState<boolean>(!!id);
  const [savedFilter, setSavedFilter] = useState<
    LegacySavedFilter | undefined
  >();
  const { selectedAccountId, accountRef } = useContext(AccountPickerContext);
  // A draft of this id (in Studio) is read in place of the stored one
  const drafts = useContext(DraftSavedFiltersContext);
  const draft = id ? drafts[id] : undefined;

  useEffect(() => {
    if (draft) {
      setSavedFilter(migrate(draft));
      setIsLoading(false);
      return;
    }
    if (!id) {
      setIsLoading(false);
      setSavedFilter(undefined);
    } else {
      setIsLoading(true);
      const listener = STORE.getLegacySavedFiltersRef({
        accountId: selectedAccountId,
      })
        .doc(id)
        .onSnapshot((snapshot) => {
          const f = snapshot.data();
          if (!f) {
            return;
          }
          const sf = migrate(f);
          setSavedFilter(sf);
          setIsLoading(false);
        });

      return () => {
        listener();
      };
    }
  }, [accountRef, draft, id, selectedAccountId]);

  return {
    savedFilter,
    isLoading,
  };
};

export default useLegacySavedFilter;
